<template>
  <!--<SiteNav/> -->
  <RouterView />
  <!-- <BeetCredits/>
  <Gdpr/> -->
</template>

<script>
import { SiteNav } from '@/components/navigation'
import { BeetCredits } from '@/components/small'
import { useLangRouter } from '@/extensions/langRouter'

import Gdpr from './components/gdpr/Gdpr.vue'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: {
    Gdpr,
    BeetCredits,
    SiteNav,
  },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
  },
  updated() {
    this.$nextTick(() => {
      const el = this.$route.hash ? document.querySelector(this.$route.hash) : null
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    })
  },
}
</script>
